import React, { useContext, useState } from 'react';
import Typography from '@mui/material/Typography';
import { getUserHistorique, getUserHistoriqueFavoris } from '../services/requestHandler';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import RestoreIcon from '@mui/icons-material/Restore';
import FavoriteIcon from '@mui/icons-material/Favorite';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import List from '@mui/material/List';
import CarteHistorique from '../components/historique/carteHistorique';
import translate from '../i18n/translate';
import { SessionContext } from '../services/SessionProvider';

export default function HistoriqueStrategies(){
  const { getUserId } = useContext(SessionContext);

  const [userHistorique, setUserHistorique] = useState(null)
  const [userFavoris, setUserFavoris] = useState(null)
  const [value, setValue] = React.useState(0);
  const [reloadComponent, needReloadComponent] = useState(false)
  const ref = React.useRef(null);

  React.useEffect(()=> {
    getHistorique();
    // eslint-disable-next-line
  }, [reloadComponent]);

  async function getHistorique() {
    const userId = getUserId();
    const limit = 5;
    const data = await getUserHistorique(userId, limit);
    const dataFav = await getUserHistoriqueFavoris(userId);
    
    setUserFavoris(dataFav);
    setUserHistorique(data);
  }

    return (
      <main style={{display: "grid", justifyItems: "center", marginTop: "3rem"}}>
          <Typography component="h1" variant="h2" align="center" color="text.primary" gutterBottom >{translate("historique.titre")} </Typography>
          <div style={{width: "50%"}}>
            <Box sx={{ pb: 7, backgroundColor: "transparent" }} ref={ref}>
            <Paper sx={{ position: 'center', bottom: 0, left: 0, right: 0}} elevation={3}>
                <BottomNavigation
                  showLabels
                  value={value}
                  justifycontent="space-around"
                  onChange={(event, newValue) => {
                    setValue(newValue);
                  }}
                >
                  <BottomNavigationAction label={translate("historique.recent")} sx={{"&:hover": {color: "#8EBF55"}}} icon={<RestoreIcon />} />
                  <BottomNavigationAction label={translate("historique.favoris")} sx={{"&:hover": {color: "#8EBF55"}}} icon={<FavoriteIcon />} />
                </BottomNavigation>
              </Paper>
              <CssBaseline />
              {userHistorique !== null && value === 0 &&
              <List style={{width: "100%"}}>
                {userHistorique && userHistorique.map((historique) => (
                  <Grid item={true} key={historique.session_id} xs={2} sm={2} md={6}>
                    <CarteHistorique historique={historique} needReloadComponent={needReloadComponent} reloadComponent={reloadComponent}/>
                  </Grid>
                ))}
              </List>}
              {userFavoris !== null && value === 1 &&
              <List>
                {userFavoris && userFavoris.map((historique) => (
                  <Grid item={true} key={historique.session_id} xs={2} sm={2} md={6}>
                    <CarteHistorique historique={historique} needReloadComponent={needReloadComponent} reloadComponent={reloadComponent}/>
                  </Grid>
                ))}
              </List>}
            </Box>            
          </div>
      </main>
    );
  }